/** Направление сообщения. */
export enum ClientMessageDirection {
    /** Исходящее (клиенту). */
    Outcome = "outcome",

    /** Входящее (от клиента). */
    Income = "income",
}
